import React, { Suspense } from 'react';


const ThemedComponent = (component, fallback) => {
  return (props) => {
    const Component = React.lazy(
      () => import(`../themes/${ THEME }.js`).then(module => ({ default: module[component] }))
    );
    if (!fallback) {
      fallback = <></>;
    }
    return (
      <Suspense fallback={ fallback }>
        <Component { ...props } />
      </Suspense>
    );
  };
};

const Loaders = {
  'nzf_2020': (
    <div className='loading-space relative flex flex-jc-center flex-ai-center'>
      <div className='spinner' />
    </div>
  ),
};


const ThemedTitle = ThemedComponent('Title');

const ThemedCalendar = ThemedComponent('Calendar');
const ThemedCalendarDay = ThemedComponent('CalendarDay');
const ThemedCalendarMonth = ThemedComponent('CalendarMonth');

const ThemedEventList = ThemedComponent('EventList', Loaders[THEME]);
const ThemedEventCard = ThemedComponent('EventCard');
const ThemedExtraEventTile = ThemedComponent('ExtraEventTile');

const ThemedFilterList = ThemedComponent('FilterList');
const ThemedFilter = ThemedComponent('Filter');
const ThemedOption = ThemedComponent('Option');

const ThemedModal = ThemedComponent('Modal');

const ThemedShortlistButton = ThemedComponent('ShortlistButton');
const ThemedShortlistCount = ThemedComponent('ShortlistCount');

const ThemedShortlistAlert = ThemedComponent('ShortlistAlert');
const ThemedShortlistFormSubmit = ThemedComponent('ShortlistFormSubmit');
const ThemedShortlistFormWrapper = ThemedComponent('ShortlistFormWrapper');
const ThemedShortlistBuyButton = ThemedComponent('ShortlistBuyButton');
const ThemedShortlistRemoveButton = ThemedComponent('ShortlistRemoveButton');
const ThemedShortlistSessionSelect = ThemedComponent('ShortlistSessionSelect');

const ThemedVideoButton = ThemedComponent('VideoButton');
const ThemedVideoOverlay = ThemedComponent('VideoOverlay');

export {
  ThemedCalendar,
  ThemedCalendarDay,
  ThemedCalendarMonth,
  ThemedEventList,
  ThemedEventCard,
  ThemedExtraEventTile,
  ThemedFilterList,
  ThemedFilter,
  ThemedOption,
  ThemedModal,
  ThemedShortlistButton,
  ThemedShortlistCount,
  ThemedShortlistAlert,
  ThemedShortlistFormSubmit,
  ThemedShortlistFormWrapper,
  ThemedShortlistBuyButton,
  ThemedShortlistRemoveButton,
  ThemedShortlistSessionSelect,
  ThemedTitle,
  ThemedVideoButton,
  ThemedVideoOverlay,
};
